import config from '@app/config'

const getLocale = (campaignLocales: string[]) => {
  const possibleLocales = new URL(window.location.href).pathname.split('/').slice(1,3)
  const urlLocale = possibleLocales.find((locale) => campaignLocales?.includes(locale))

  if (urlLocale) return urlLocale
  if (campaignLocales?.length) return campaignLocales[0]
  return 'en-GB'
}

export const locale = getLocale(config?.campaign?.campaignLocales)

export const getMessages = (lang: string): any => {
  try {
    return require(`@lang/compiled/${lang.split('-')[0]}.json`)
  } catch (error) {
    return null
  }
}
